import React from "react";
import { Button, useDisclosure } from "@chakra-ui/react";
import Icon from "@mdi/react";
import { mdiCamera } from "@mdi/js";
import { FormattedMessage } from "react-intl";
import CaptureModal from "./CaptureModalComponent";

/**
 * @callback onCaptureOnMobileComplete
 * @param {Object.<string, string>} uploads - returns a dict where the keys are what images were requested and values are base64 strings
 */

/**
 * CaptureOnMobileButton
 * @name CaptureOnMobileButton
 * @param {string} docTypeConfigKey - References a document upload type that can be found in the 'uploadConfigs' files.  This is so the upload page can know what ref images to show, and which keys to use when sending back upload info.
 * @param {onCaptureOnMobileComplete} onComplete
 * @param {boolean} [isFullWidth=false] - Set the button to full width
 * @returns JSX.Element
 */
const CaptureButtonComponent = ({ docTypeConfigKey, onComplete, isFullWidth = false }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <>
      <Button
        leftIcon={<Icon path={mdiCamera} size={"1em"} />}
        onClick={onOpen}
        width={isFullWidth ? "100%" : "auto"}
      >
        <FormattedMessage defaultMessage="Capture on mobile" description="Button label" />
      </Button>
      <CaptureModal
        isOpen={isOpen}
        onClose={onClose}
        docTypeConfigKey={docTypeConfigKey}
        onComplete={onComplete}
      />
    </>
  );
};

export default CaptureButtonComponent;
